import React from 'react'
import { NavLink } from 'react-router-dom'
import './style.css'

const AppMenuLink = ({ to, label, ...other }) => (
  <li className="app-menu-link-wrapper">
    <NavLink to={to}
      className="app-menu-link"
      activeClassName="app-menu-link-active">
      {label}
    </NavLink>
  </li>
)

export default AppMenuLink
